//@ts-ignore
import {i18n} from './../i18n-setup';

/**
 * Хелпер для работы с датами
 */
export default class DateHelper {

    /**
     * Преобразование секунд в дату
     * @param seconds
     */
    public static secondsToDate(seconds: number): string
    {

        let days: number = Math.floor(seconds / (3600 * 24));
        let hours: number = Math.floor(seconds % (3600 * 24) / 3600);
        let minutes: number = Math.floor(seconds % 3600 / 60);

        let dDisplay = days > 0 ? days + '&thinsp;' + i18n.t('date.d') + '&thinsp;' + ':' : "";
        let hDisplay = hours > 0 ? hours + '&thinsp;' + i18n.t('date.h') + '&thinsp;' + ':' : "";
        let mDisplay = minutes > 0 ? minutes + '&thinsp;' + i18n.t('date.min') + '&thinsp;' + ' ' : "";

        return dDisplay + hDisplay + mDisplay;
    }

    /**
     * Преобразование секунд в ч:м
     * @param seconds
     */
    public static convertSecondsToHS(seconds: number): string
    {
        let hours: number = Math.floor(seconds % (3600 * 24) / 3600);
        let minutes = Math.floor(seconds % 3600 / 60).toString().padStart(2, '0');

        return `${hours}:${minutes}`;
    }
}
